import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import { CircularProgress } from "@material-ui/core";
import { WarningModal, AlertModal } from "../../components/Modal";
import { REQSendPushNoti, CleanUpPushNoti } from "./redux/actions";
import DevicePreview from "./DevicePreview";
import {
  initialForm,
  buildRequests,
  buildTargets,
  validateForm
} from "./payload";
import { KNOWN_DATA_TYPES, PUSH_SEND_URL } from "./config";
import { saveCampaign, makeCampaignId } from "../PushNotiList/history";
import "react-datepicker/dist/react-datepicker.css";
import "./style.scss";

const STEPS = [
  { no: 1, title: "การแจ้งเตือน", en: "Notification" },
  { no: 2, title: "เป้าหมาย", en: "Target" },
  { no: 3, title: "การกำหนดเวลา", en: "Scheduling" },
  { no: 4, title: "เหตุการณ์ Conversion", en: "Conversion events", optional: true },
  { no: 5, title: "ตัวเลือกเพิ่มเติม", en: "Additional options", optional: true }
];

const TARGET_MODES = [
  { value: "ALL", label: "ผู้ใช้ทั้งหมด (topic ios / android)" },
  { value: "TOPIC", label: "ระบุ topic เอง" },
  { value: "USER", label: "ระบุผู้ใช้ (customer uuid / unitholder id)" },
  { value: "TOKEN", label: "ระบุเครื่อง (FCM registration token)" }
];

function PushNotiCompose(props) {
  const {
    REQSendPushNoti,
    CleanUpPushNoti,
    REQStrSendPushNoti,
    SendResults,
    SendSummary,
    history
  } = props;

  const oNeedAuth = JSON.parse(localStorage.getItem("NeedAuth"));

  // "Reuse" on the Campaign page hands the previous form over to be refilled
  const oReuse =
    history.location.state && history.location.state.campaign
      ? history.location.state.campaign.form
      : null;

  const [form, SETxForm] = useState(
    oReuse
      ? {
          ...initialForm,
          ...oReuse,
          scheduledAt: oReuse.scheduledAt ? new Date(oReuse.scheduledAt) : null
        }
      : initialForm
  );
  const [oStep, SETxStep] = useState(1);
  const [oVisited, SETxVisited] = useState([1]);
  const [oReview, SETxReview] = useState(false);
  const [oErrors, SETxErrors] = useState([]);
  const [oShwConfirm, SETxShwConfirm] = useState(false);
  const [oShwResult, SETxShwResult] = useState(false);
  const [oShwScheduled, SETxShwScheduled] = useState(false);
  const [oShwJson, SETxShwJson] = useState(false);

  useEffect(() => {
    return () => {
      CleanUpPushNoti();
    };
  }, []);

  useEffect(() => {
    if (SendSummary) {
      SETxShwResult(true);
    }
  }, [SendSummary]);

  const SETxField = name => ({ target: { value } }) => {
    SETxForm(oldValues => ({ ...oldValues, [name]: value }));
  };

  const SETxValue = (name, value) => {
    SETxForm(oldValues => ({ ...oldValues, [name]: value }));
  };

  const SETxPlatform = platform => () => {
    SETxForm(oldValues => ({
      ...oldValues,
      platforms: { ...oldValues.platforms, [platform]: !oldValues.platforms[platform] }
    }));
  };

  const SETxCustomData = (index, key, value) => {
    SETxForm(oldValues => {
      const customData = oldValues.customData.map((item, i) =>
        i === index ? { ...item, [key]: value } : item
      );
      return { ...oldValues, customData };
    });
  };

  const ADDxCustomData = () => {
    SETxForm(oldValues => ({
      ...oldValues,
      customData: [...oldValues.customData, { key: "", value: "" }]
    }));
  };

  const DELxCustomData = index => {
    SETxForm(oldValues => ({
      ...oldValues,
      customData: oldValues.customData.filter((item, i) => i !== index)
    }));
  };

  const GOTOxStep = next => {
    SETxStep(next);
    SETxReview(false);
    SETxVisited(oldValues =>
      oldValues.includes(next) ? oldValues : [...oldValues, next]
    );
  };

  const oTargets = buildTargets(form);
  const oRequests = buildRequests(form);

  const GENxCampaign = status => ({
    id: makeCampaignId(),
    name: form.campaignName || form.title || "(ไม่มีชื่อแคมเปญ)",
    title: form.title,
    body: form.body,
    imageUrl: form.imageUrl,
    targetMode: form.targetMode,
    targets: oTargets.map(target => target.label),
    scheduleMode: form.scheduleMode,
    scheduledAt: form.scheduledAt ? new Date(form.scheduledAt).toISOString() : null,
    createdAt: new Date().toISOString(),
    createdBy: oNeedAuth ? oNeedAuth.Email : "",
    endpoint: PUSH_SEND_URL,
    status,
    payload: oRequests.length > 0 ? oRequests[0].payload : null,
    form
  });

  const SAVExDraft = () => {
    saveCampaign(GENxCampaign("DRAFT"));
    history.push("/PushNoti_Campaigns");
  };

  const REVIEWxCampaign = () => {
    const errors = validateForm(form);
    SETxErrors(errors);
    if (errors.length === 0) {
      SETxReview(true);
      SETxStep(0);
    }
  };

  const PUBLISHxCampaign = () => {
    SETxShwConfirm(false);

    if (form.scheduleMode === "SCHEDULED") {
      // No scheduler on the backend yet — this only records a scheduled campaign
      saveCampaign(GENxCampaign("SCHEDULED"));
      SETxShwScheduled(true);
      return;
    }

    REQSendPushNoti({
      requests: oRequests,
      campaign: GENxCampaign("SENDING")
    });
  };

  const RENDxStepHeader = stepDef => {
    const active = oStep === stepDef.no;
    const visited = oVisited.includes(stepDef.no);
    return (
      <button
        type="button"
        className={`push-noti-step-header${active ? " active" : ""}`}
        onClick={() => GOTOxStep(stepDef.no)}
      >
        <span className={`push-noti-step-circle${visited ? " visited" : ""}`}>
          {stepDef.no}
        </span>
        <span className="push-noti-step-title">
          {stepDef.title}
          <span className="push-noti-step-en">{stepDef.en}</span>
        </span>
        {stepDef.optional ? (
          <span className="push-noti-step-optional">ไม่บังคับ</span>
        ) : null}
      </button>
    );
  };

  const RENDxStep1 = () => (
    <div className="push-noti-step-body">
      <div className="push-noti-field">
        <label className="push-noti-label">ชื่อเรื่องการแจ้งเตือน</label>
        <input
          className="push-noti-input"
          maxLength={200}
          placeholder="PRINCIPAL TH"
          value={form.title}
          onChange={SETxField("title")}
        />
      </div>

      <div className="push-noti-field">
        <label className="push-noti-label">
          ข้อความแจ้งเตือน <span className="push-noti-required">*</span>
        </label>
        <textarea
          className="push-noti-textarea"
          rows={4}
          placeholder="ข้อความที่จะแสดงบนเครื่องของผู้ใช้"
          value={form.body}
          onChange={SETxField("body")}
        />
      </div>

      <div className="push-noti-field">
        <label className="push-noti-label">รูปภาพการแจ้งเตือน (URL)</label>
        <input
          className="push-noti-input"
          placeholder="https://..."
          value={form.imageUrl}
          onChange={SETxField("imageUrl")}
        />
        <p className="push-noti-hint">
          backend ยังไม่รองรับ <code>notification.image</code> — URL นี้จะถูกส่งไปใน{" "}
          <code>data.image</code> ให้แอปนำไปแสดงเอง
        </p>
      </div>

      <div className="push-noti-field">
        <label className="push-noti-label">ชื่อการแจ้งเตือน (ใช้ภายใน)</label>
        <input
          className="push-noti-input"
          placeholder="เช่น promo-dec-2026"
          value={form.campaignName}
          onChange={SETxField("campaignName")}
        />
      </div>

      <div className="push-noti-step-actions">
        <button type="button" className="push-noti-next" onClick={() => GOTOxStep(2)}>
          ถัดไป
        </button>
      </div>
    </div>
  );

  const RENDxStep2 = () => (
    <div className="push-noti-step-body">
      <div className="push-noti-field">
        <label className="push-noti-label">แอป</label>
        <div className="push-noti-checkbox-row">
          <label className="push-noti-checkbox">
            <input
              type="checkbox"
              checked={form.platforms.ios}
              onChange={SETxPlatform("ios")}
              disabled={form.targetMode !== "ALL"}
            />
            <span>iOS</span>
          </label>
          <label className="push-noti-checkbox">
            <input
              type="checkbox"
              checked={form.platforms.android}
              onChange={SETxPlatform("android")}
              disabled={form.targetMode !== "ALL"}
            />
            <span>Android</span>
          </label>
        </div>
        <p className="push-noti-hint">
          แอปจะ subscribe topic ตามแพลตฟอร์ม (<code>ios</code> / <code>android</code>) ตอนเข้าสู่ระบบ
        </p>
      </div>

      <div className="push-noti-field">
        <label className="push-noti-label">กลุ่มเป้าหมาย</label>
        {TARGET_MODES.map(mode => (
          <label className="push-noti-radio" key={mode.value}>
            <input
              type="radio"
              checked={form.targetMode === mode.value}
              onChange={() => SETxValue("targetMode", mode.value)}
            />
            <span>{mode.label}</span>
          </label>
        ))}
      </div>

      {form.targetMode === "TOPIC" ? (
        <div className="push-noti-field">
          <label className="push-noti-label">Topic (บรรทัดละ 1 ค่า)</label>
          <textarea
            className="push-noti-textarea"
            rows={3}
            placeholder={"ios\nandroid"}
            value={form.topics}
            onChange={SETxField("topics")}
          />
        </div>
      ) : null}

      {form.targetMode === "USER" ? (
        <div className="push-noti-field">
          <label className="push-noti-label">
            customer uuid หรือ unitholder id (บรรทัดละ 1 ค่า)
          </label>
          <textarea
            className="push-noti-textarea"
            rows={3}
            placeholder={"3f0c1f2e-....\n0123456789"}
            value={form.users}
            onChange={SETxField("users")}
          />
          <p className="push-noti-hint">
            แอปจะ subscribe topic ชื่อเดียวกับ userId และ unitholderId ตอนเข้าสู่ระบบ
          </p>
        </div>
      ) : null}

      {form.targetMode === "TOKEN" ? (
        <div className="push-noti-field">
          <label className="push-noti-label">FCM registration token (บรรทัดละ 1 ค่า)</label>
          <textarea
            className="push-noti-textarea"
            rows={4}
            placeholder="fMEP0vJqS0-..."
            value={form.tokens}
            onChange={SETxField("tokens")}
          />
        </div>
      ) : null}

      <div className="push-noti-target-summary">
        ระบบจะยิงทั้งหมด <b>{oTargets.length}</b> ครั้ง (1 target ต่อ 1 request ตามที่ backend รองรับ)
        {oTargets.length > 0 ? (
          <ul>
            {oTargets.slice(0, 10).map((target, index) => (
              <li key={`${target.kind}-${index}`}>{target.label}</li>
            ))}
            {oTargets.length > 10 ? <li>… และอีก {oTargets.length - 10} รายการ</li> : null}
          </ul>
        ) : null}
      </div>

      <div className="push-noti-step-actions">
        <button type="button" className="push-noti-back" onClick={() => GOTOxStep(1)}>
          ย้อนกลับ
        </button>
        <button type="button" className="push-noti-next" onClick={() => GOTOxStep(3)}>
          ถัดไป
        </button>
      </div>
    </div>
  );

  const RENDxStep3 = () => (
    <div className="push-noti-step-body">
      <div className="push-noti-field">
        <label className="push-noti-radio">
          <input
            type="radio"
            checked={form.scheduleMode === "NOW"}
            onChange={() => SETxValue("scheduleMode", "NOW")}
          />
          <span>ส่งทันที</span>
        </label>
        <label className="push-noti-radio">
          <input
            type="radio"
            checked={form.scheduleMode === "SCHEDULED"}
            onChange={() => SETxValue("scheduleMode", "SCHEDULED")}
          />
          <span>ตั้งเวลาส่ง</span>
        </label>
      </div>

      {form.scheduleMode === "SCHEDULED" ? (
        <Fragment>
          <div className="push-noti-field">
            <label className="push-noti-label">วันและเวลา (Asia/Bangkok)</label>
            <DatePicker
              selected={form.scheduledAt}
              onChange={date => SETxValue("scheduledAt", date)}
              showTimeSelect
              timeIntervals={15}
              minDate={new Date()}
              dateFormat="dd/MM/yyyy HH:mm"
              timeFormat="HH:mm"
              className="push-noti-input"
              placeholderText="เลือกวันและเวลา"
            />
          </div>
          <div className="push-noti-warning">
            backend ยังไม่มีตัวจับเวลาส่ง (POST /api/v1/push/notification ส่งออกทันทีเสมอ)
            แคมเปญที่ตั้งเวลาไว้จะถูก <b>บันทึกเป็นรายการรอส่ง</b> ในหน้า Campaign เท่านั้น
            และจะยังไม่ถูกส่งจนกว่า backend จะรองรับ
          </div>
        </Fragment>
      ) : null}

      <div className="push-noti-step-actions">
        <button type="button" className="push-noti-back" onClick={() => GOTOxStep(2)}>
          ย้อนกลับ
        </button>
        <button type="button" className="push-noti-next" onClick={() => GOTOxStep(4)}>
          ถัดไป
        </button>
      </div>
    </div>
  );

  const RENDxStep4 = () => (
    <div className="push-noti-step-body">
      <div className="push-noti-field">
        <label className="push-noti-label">เหตุการณ์ Conversion (ไม่บังคับ)</label>
        <input
          className="push-noti-input"
          placeholder="เช่น first_open, purchase"
          value={form.conversionEvent}
          onChange={SETxField("conversionEvent")}
        />
        <p className="push-noti-hint">
          ค่านี้จะถูกส่งไปใน <code>data.conversion_event</code> เพื่อให้แอปยิง analytics เอง
          (ไม่ได้ผูกกับ Google Analytics เหมือนใน Firebase console)
        </p>
      </div>

      <div className="push-noti-step-actions">
        <button type="button" className="push-noti-back" onClick={() => GOTOxStep(3)}>
          ย้อนกลับ
        </button>
        <button type="button" className="push-noti-next" onClick={() => GOTOxStep(5)}>
          ถัดไป
        </button>
      </div>
    </div>
  );

  const RENDxStep5 = () => (
    <div className="push-noti-step-body">
      <div className="push-noti-field">
        <label className="push-noti-label">ประเภทข้อมูล (data.type)</label>
        <select
          className="push-noti-input"
          value={form.dataType}
          onChange={SETxField("dataType")}
        >
          <option value="">— ไม่ระบุ —</option>
          {KNOWN_DATA_TYPES.map(type => (
            <option value={type} key={type}>
              {type}
            </option>
          ))}
        </select>
        <p className="push-noti-hint">
          แอปรู้จัก <code>qr_code</code> และ <code>allotment</code> (RootRoute.tsx)
          ค่าอื่นให้เพิ่มเองในตาราง custom data ด้านล่าง
        </p>
      </div>

      <div className="push-noti-field">
        <label className="push-noti-label">ลิงก์ปลายทาง (data.deeplink)</label>
        <input
          className="push-noti-input"
          placeholder="principalth://..."
          value={form.deeplink}
          onChange={SETxField("deeplink")}
        />
      </div>

      <div className="push-noti-field-row">
        <div className="push-noti-field">
          <label className="push-noti-label">ความสำคัญ (android.priority)</label>
          <select
            className="push-noti-input"
            value={form.priority}
            onChange={SETxField("priority")}
          >
            <option value="high">high</option>
            <option value="normal">normal</option>
          </select>
        </div>

        <div className="push-noti-field">
          <label className="push-noti-label">อายุข้อความ (ชั่วโมง)</label>
          <input
            className="push-noti-input"
            type="number"
            min="0"
            max="672"
            placeholder="เช่น 24"
            value={form.ttlHours}
            onChange={SETxField("ttlHours")}
          />
          <p className="push-noti-hint">
            ส่งเป็น <code>android.ttl</code> หน่วยมิลลิวินาที (สูงสุด 28 วัน)
          </p>
        </div>
      </div>

      <div className="push-noti-field-row">
        <div className="push-noti-field">
          <label className="push-noti-label">ไอคอน Android (android.notification.icon)</label>
          <input
            className="push-noti-input"
            placeholder="ic_notification"
            value={form.androidIcon}
            onChange={SETxField("androidIcon")}
          />
        </div>
        <div className="push-noti-field">
          <label className="push-noti-label">สี Android (android.notification.color)</label>
          <input
            className="push-noti-input"
            placeholder="#0275b6"
            value={form.androidColor}
            onChange={SETxField("androidColor")}
          />
        </div>
      </div>

      <div className="push-noti-field-row">
        <div className="push-noti-field">
          <label className="push-noti-label">ช่องทางแจ้งเตือน Android (data.channel_id)</label>
          <input
            className="push-noti-input"
            placeholder="default"
            value={form.androidChannelId}
            onChange={SETxField("androidChannelId")}
          />
        </div>
        <div className="push-noti-field">
          <label className="push-noti-label">Badge บน iOS (data.badge)</label>
          <input
            className="push-noti-input"
            type="number"
            min="0"
            placeholder="1"
            value={form.iosBadge}
            onChange={SETxField("iosBadge")}
          />
        </div>
      </div>

      <div className="push-noti-field">
        <label className="push-noti-checkbox">
          <input
            type="checkbox"
            checked={form.sound}
            onChange={() => SETxValue("sound", !form.sound)}
          />
          <span>เปิดเสียง (ส่ง data.sound = false เมื่อปิด)</span>
        </label>
        <label className="push-noti-checkbox">
          <input
            type="checkbox"
            checked={form.contentAvailable}
            onChange={() => SETxValue("contentAvailable", !form.contentAvailable)}
          />
          <span>ปลุกแอปเบื้องหลังบน iOS (apns.payload.aps.contentAvailable)</span>
        </label>
      </div>

      <div className="push-noti-field">
        <label className="push-noti-label">ข้อมูลเพิ่มเติม (custom data)</label>
        {form.customData.map((item, index) => (
          <div className="push-noti-kv-row" key={`kv-${index}`}>
            <input
              className="push-noti-input"
              placeholder="key"
              value={item.key}
              onChange={event => SETxCustomData(index, "key", event.target.value)}
            />
            <input
              className="push-noti-input"
              placeholder="value"
              value={item.value}
              onChange={event => SETxCustomData(index, "value", event.target.value)}
            />
            <button
              type="button"
              className="push-noti-kv-remove"
              onClick={() => DELxCustomData(index)}
            >
              ลบ
            </button>
          </div>
        ))}
        <button type="button" className="push-noti-kv-add" onClick={ADDxCustomData}>
          + เพิ่มข้อมูล
        </button>
      </div>

      <div className="push-noti-step-actions">
        <button type="button" className="push-noti-back" onClick={() => GOTOxStep(4)}>
          ย้อนกลับ
        </button>
        <button type="button" className="push-noti-next" onClick={REVIEWxCampaign}>
          ตรวจสอบ
        </button>
      </div>
    </div>
  );

  const RENDxStepBody = stepNo => {
    if (stepNo === 1) return RENDxStep1();
    if (stepNo === 2) return RENDxStep2();
    if (stepNo === 3) return RENDxStep3();
    if (stepNo === 4) return RENDxStep4();
    return RENDxStep5();
  };

  const RENDxSummary = stepNo => {
    if (stepNo === 1) {
      return form.title || form.body ? `${form.title} — ${form.body}` : "ยังไม่ได้กรอก";
    }
    if (stepNo === 2) {
      return `${oTargets.length} target`;
    }
    if (stepNo === 3) {
      return form.scheduleMode === "NOW"
        ? "ส่งทันที"
        : `ตั้งเวลา ${form.scheduledAt ? new Date(form.scheduledAt).toLocaleString("th-TH") : "-"}`;
    }
    if (stepNo === 4) {
      return form.conversionEvent || "ไม่ระบุ";
    }
    return `${Object.keys(oRequests.length > 0 ? oRequests[0].payload.data : {}).length} data key`;
  };

  return (
    <Fragment>
      {REQStrSendPushNoti ? (
        <div className="funds-list-progress">
          <CircularProgress />
          <p className="funds-list-progress-text">กำลังส่งการแจ้งเตือน...</p>
        </div>
      ) : null}

      <div className="push-noti-container">
        <div className="push-noti-topbar">
          <div>
            <h2 className="push-noti-heading">เขียนการแจ้งเตือน</h2>
            <p className="push-noti-subheading">
              ส่งผ่าน <code>{PUSH_SEND_URL}</code>
            </p>
          </div>
          <div className="push-noti-topbar-actions">
            <button
              type="button"
              className="push-noti-ghost"
              onClick={() => history.push("/PushNoti_Campaigns")}
            >
              ยกเลิก
            </button>
            <button type="button" className="push-noti-ghost" onClick={SAVExDraft}>
              บันทึกฉบับร่าง
            </button>
          </div>
        </div>

        <div className="push-noti-body">
          <div className="push-noti-steps">
            {STEPS.map(stepDef => (
              <div
                className={`push-noti-step${oStep === stepDef.no ? " active" : ""}`}
                key={stepDef.no}
              >
                {RENDxStepHeader(stepDef)}
                {oStep === stepDef.no ? (
                  RENDxStepBody(stepDef.no)
                ) : (
                  <p className="push-noti-step-summary">{RENDxSummary(stepDef.no)}</p>
                )}
              </div>
            ))}

            {oErrors.length > 0 ? (
              <div className="push-noti-errors">
                <b>ตรวจสอบข้อมูลก่อนส่ง</b>
                <ul>
                  {oErrors.map((error, index) => (
                    <li key={`err-${index}`}>{error}</li>
                  ))}
                </ul>
              </div>
            ) : null}

            {oReview ? (
              <div className="push-noti-review">
                <h3>ตรวจสอบ</h3>
                <dl>
                  <dt>ชื่อแคมเปญ</dt>
                  <dd>{form.campaignName || "(ไม่มีชื่อแคมเปญ)"}</dd>
                  <dt>ชื่อเรื่อง</dt>
                  <dd>{form.title || "-"}</dd>
                  <dt>ข้อความ</dt>
                  <dd>{form.body}</dd>
                  <dt>เป้าหมาย</dt>
                  <dd>
                    {oTargets.map((target, index) => (
                      <div key={`review-target-${index}`}>{target.label}</div>
                    ))}
                  </dd>
                  <dt>เวลาส่ง</dt>
                  <dd>
                    {form.scheduleMode === "NOW"
                      ? "ทันที"
                      : new Date(form.scheduledAt).toLocaleString("th-TH")}
                  </dd>
                </dl>
                <div className="push-noti-step-actions">
                  <button
                    type="button"
                    className="push-noti-back"
                    onClick={() => GOTOxStep(5)}
                  >
                    แก้ไข
                  </button>
                  <button
                    type="button"
                    className="push-noti-publish"
                    onClick={() => SETxShwConfirm(true)}
                  >
                    {form.scheduleMode === "NOW" ? "เผยแพร่" : "บันทึกการตั้งเวลา"}
                  </button>
                </div>
              </div>
            ) : null}
          </div>

          <div className="push-noti-side">
            <DevicePreview title={form.title} body={form.body} imageUrl={form.imageUrl} />

            <div className="push-noti-json">
              <button
                type="button"
                className="push-noti-json-toggle"
                onClick={() => SETxShwJson(!oShwJson)}
              >
                {oShwJson ? "ซ่อน" : "ดู"} JSON ที่จะส่ง ({oRequests.length} request)
              </button>
              {oShwJson ? (
                <pre className="push-noti-json-body">
                  {JSON.stringify(
                    oRequests.map(item => item.payload),
                    null,
                    2
                  )}
                </pre>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <WarningModal
        show={oShwConfirm}
        onHide={() => SETxShwConfirm(false)}
        onHandleGo={PUBLISHxCampaign}
        onHandleCancel={() => SETxShwConfirm(false)}
        type={"Disapprove"}
        status={"1"}
        title={
          form.scheduleMode === "NOW"
            ? `ส่งการแจ้งเตือนไปยัง ${oTargets.length} target ตอนนี้เลยหรือไม่?`
            : "บันทึกแคมเปญที่ตั้งเวลาไว้หรือไม่?"
        }
      />

      <AlertModal
        show={oShwScheduled}
        onHide={() => {
          SETxShwScheduled(false);
          history.push("/PushNoti_Campaigns");
        }}
        onHandleOK={() => {
          SETxShwScheduled(false);
          history.push("/PushNoti_Campaigns");
        }}
        title="บันทึกแคมเปญที่ตั้งเวลาไว้แล้ว"
        body="ยังไม่ได้ส่งออก — ต้องรอ backend รองรับการตั้งเวลาก่อน"
      />

      <AlertModal
        show={oShwResult}
        onHide={() => SETxShwResult(false)}
        onHandleOK={() => {
          SETxShwResult(false);
          history.push("/PushNoti_Campaigns");
        }}
        title={
          SendSummary
            ? `ส่งสำเร็จ ${SendSummary.succeeded} / ${SendSummary.total} target`
            : ""
        }
        body={
          SendResults && SendResults.length > 0 ? (
            <span className="push-noti-result-list">
              {SendResults.map((item, index) => (
                <span
                  className={item.ok ? "push-noti-result ok" : "push-noti-result fail"}
                  key={`send-result-${index}`}
                >
                  {item.target.label}: {item.ok ? "สำเร็จ" : `ล้มเหลว (${item.message})`}
                </span>
              ))}
            </span>
          ) : (
            ""
          )
        }
      />
    </Fragment>
  );
}

const withConnect = connect(
  state => ({
    ...state.pushNotiComposeReducer
  }),
  {
    REQSendPushNoti,
    CleanUpPushNoti
  }
);

export default compose(
  withConnect,
  withRouter
)(PushNotiCompose);
